import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react';
import { WalletConnectProjectId, chains, FALLBACK_RPC_PROVIDERS } from '../util/constants';

// Create ethers config - Web3Modal v6 with ethers v6
// defaultConfig only accepts ConfigOptions (metadata, enableEIP6963, etc.)
// projectId is passed to createWeb3Modal, not defaultConfig
const ethersConfig = defaultConfig({
  metadata: {
    name: 'Velodrome Finance',
    description: 'Velodrome Finance - Next Generation AMM',
    url: window.location.origin,
    icons: [`${window.location.origin}/vel.svg`]
  }
});

// Optional: in development, proxy RPC through a CORS proxy to fix "Failed to fetch" (browser CORS)
const rpcProxy = process.env.NODE_ENV === 'development' && process.env.REACT_APP_RPC_PROXY;

function getRpcUrl(chain) {
  const url = chain.rpcUrl || (chain.rpcUrls && chain.rpcUrls[0]);
  if (rpcProxy && url && typeof url === 'string') {
    try {
      return rpcProxy + encodeURIComponent(url);
    } catch (_) {
      return url;
    }
  }
  return url;
}

// Convert chains object to array format expected by Web3Modal.
// Use first URL from fallbacks so we have a working RPC (fallbacks listed for future use).
const chainsArray = Object.values(chains).map(chain => {
  const primary = getRpcUrl(chain) || chain.rpcUrl;
  const fallbacks = FALLBACK_RPC_PROVIDERS[chain.chainId] || [];
  const allUrls = [primary, ...fallbacks].filter(Boolean);
  const uniqueUrls = [...new Set(allUrls)];
  const rpcUrl = uniqueUrls[0] || primary;
  return {
    chainId: chain.chainId,
    name: chain.name,
    currency: chain.currency,
    explorerUrl: chain.explorerUrl,
    rpcUrl: rpcUrl || primary
  };
});

// Initialize Web3Modal - must be called before any hooks are used
// This file is imported in index.js before App renders
try {
  if (WalletConnectProjectId) {
    createWeb3Modal({
      ethersConfig,
      projectId: WalletConnectProjectId,
      chains: chainsArray,
      enableAnalytics: false,
      enableOnramp: false,
    });
  } else {
    console.warn('WalletConnectProjectId is missing. Web3Modal may not work correctly.');
  }
} catch (e) {
  console.error('[Web3Modal] init failed – wallet connect may not work:', e?.message || e);
}
